module.exports = __webpack_public_path__ + "img/Aurora_J_uv_sleeve.f603ad52.svg";